import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import KeyboardRegular from './keyboard-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <KeyboardRegular {...validProps} />;
}
SvgComponent.iconName = 'keyboardRegular';

export const KeyboardRegularIcon = svgIconWrapper(SvgComponent);
